module.exports = __webpack_public_path__ + "h5/img/child-navc4.412b0a8e.png";